import type { WidgetType } from '@hero/schema';

/** Widget types omitted from chat bubble bodies — rendered via confirmation flow. */
export const BUBBLE_SKIPPED_WIDGET_TYPES = new Set<WidgetType>(['confirmation_card']);

export const isBubbleSkippedWidgetType = (type: WidgetType): boolean =>
  BUBBLE_SKIPPED_WIDGET_TYPES.has(type);
